export const GET_TRENDING_REQUEST = "GET_TRENDING_REQUEST";
export const GET_TRENDING_REQUEST_SUCCEEDED = "GET_TRENDING_REQUEST_SUCCEEDED";
export const GET_TRENDING_REQUEST_FAILED = "GET_TRENDING_REQUEST_FAILED";
